import type { Owner } from "../data/types";

export const OWNER_OPTIONS: Owner[] = ["Albert", "Joel", "AI Wave", "Joint"];

function localPart(email: string): string {
  const [local = ""] = email.toLowerCase().split("@");
  return local.trim();
}

export function ownerFromEmail(email: string | null | undefined): Owner {
  if (!email) return "AI Wave";

  const local = localPart(email);

  if (local === "albert" || local.startsWith("albert")) return "Albert";
  if (local === "joel" || local.startsWith("joel")) return "Joel";
  if (local === "contact" || local === "ai" || local.includes("ai-wave")) return "AI Wave";

  return "AI Wave";
}
